import { styled } from '../../Utilities';
import { ProgressIndicatorBase } from './ProgressIndicator.base';
import { getStyles } from './ProgressIndicator.styles';
/**
 * ProgressIndicator description
 */
export var ProgressIndicator = styled(ProgressIndicatorBase, getStyles, undefined, {
  scope: 'ProgressIndicator'
});